<script setup lang="ts">
import type { NuxtError } from '#app'

const props = defineProps<{
	error?: NuxtError
}>()

const isMobile = useMediaQuery('(max-width: 800px)')

const is404 = computed(() => props.error?.statusCode === 404)

const title = computed(() =>
	is404.value ? 'Seite nicht gefunden' : 'Etwas ist schiefgelaufen',
)

const subtitle = computed(() =>
	is404.value
		? 'Die angeforderte Seite existiert nicht oder wurde verschoben.'
		: 'Keine Sorge, das liegt nicht an dir. Bitte versuche es erneut.',
)
</script>

<template>
	<ion-app>
		<ion-page>
			<ion-content
				role="main"
				aria-label="Hauptinhalt"
			>
				<div class="error-page">
					<div
						class="error-content"
						:class="{ 'web-width': !isMobile }"
					>
						<ion-img
							v-if="is404"
							src="/assets/250701_vci_illustration_404.svg"
							class="error-img"
						/>
						<ion-img
							v-else
							src="/assets/250701_vci_illustration_technischer_fehler1.svg"
							class="error-img"
						/>

						<div class="error-info">
							<ion-text
								v-if="error?.statusCode"
								color="danger"
							>
								<p class="error-code">
									{{ error.statusCode }}
								</p>
							</ion-text>
							<h1>{{ title }}</h1>
							<p class="error-subtitle">
								{{ subtitle }}
							</p>
						</div>

						<VCIButton
							expand="block"
							icon="mdi-refresh"
							@click="reloadNuxtApp"
						>
							Neu versuchen
						</VCIButton>

						
					</div>
				</div>
			</ion-content>
		</ion-page>
	</ion-app>
</template>

<style scoped lang="scss">
.error-page {
	display: flex;
	align-items: center;
	justify-content: center;
	min-height: 100%;
	padding: 24px 16px;
}

.error-content {
	max-width: 1000px;
	width: 100%;
	text-align: center;

	&.web-width {
		width: 65vw;
		max-width: 750px;
	}
}

.error-img {
	width: 55%;
	max-width: 360px;
	margin: 0 auto 24px;

	@media (max-width: 800px) {
		width: 75%;
	}
}

.error-info {
	margin-bottom: 32px;

	.error-code {
		font-size: 48px;
		font-weight: 700;
		margin: 0;
		line-height: 1;

		@media (max-width: 800px) {
			font-size: 36px;
		}
	}

	h1 {
		font-size: 24px;
		font-weight: 700;
		margin: 8px 0 12px;
		color: var(--ion-text-color);

		@media (max-width: 800px) {
			font-size: 20px;
		}
	}

	.error-subtitle {
		font-size: 16px;
		color: var(--ion-color-grey-2);
		margin: 0;
		line-height: 1.5;

		@media (max-width: 800px) {
			font-size: 14px;
		}
	}
}

.dev-section {
	margin-top: 40px;
	padding-top: 24px;
	border-top: 1px dashed var(--ion-color-grey-4);
	text-align: left;

	ion-chip {
		margin-bottom: 12px;
	}

	pre {
		white-space: pre-wrap;
		word-break: break-word;
		font-size: 12px;
		line-height: 1.6;
		margin: 0;
		font-family: 'Courier New', monospace;
		color: var(--ion-color-grey-1);
	}
}
</style>
